import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import { ThemeProvider } from "@/theme/ThemeContext";

function useScrollReveal() {
    useEffect(() => {
        const els = document.querySelectorAll(".reveal");
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("in-view");
                        io.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.12, rootMargin: "0px 0px -60px 0px" }
        );
        els.forEach((el) => io.observe(el));
        return () => io.disconnect();
    }, []);
}

function Shell() {
    useScrollReveal();
    return <HomePage />;
}

function App() {
    return (
        <div className="App">
            <ThemeProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Shell />} />
                    </Routes>
                </BrowserRouter>
                <Toaster
                    theme="dark"
                    position="bottom-right"
                    toastOptions={{
                        style: {
                            background: "#0a0a0a",
                            border: "1px solid rgba(255,255,255,0.1)",
                            color: "#ffffff",
                            borderRadius: 0,
                        },
                    }}
                />
            </ThemeProvider>
        </div>
    );
}

export default App;
